import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold uppercase tracking-wide text-foreground-500">Knowledge Base</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Superbuy Spreadsheet{' '}
            <span className="italic text-primary-500">Resource Library</span>
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Explore our educational guides and resources to master product research with Superbuy Spreadsheet
          </p>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Complete Guide */}
          <Link
            to="/superbuy-spreadsheet-complete-guide"
            className="bg-background-100 rounded-2xl p-6 cursor-pointer hover:bg-accent-50/80 transition-colors group"
          >
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 rounded-lg text-xs font-semibold mb-4">
              Guide
            </span>
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
              The Complete Superbuy Spreadsheet Guide
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              Everything beginners need to know about Superbuy Spreadsheet. Learn how to navigate categories, understand product data, and make smarter shopping decisions with organized research tools.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <i className="ri-user-line text-accent-700 text-xs"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-900">SuperbuySpread Team</p>
                <p className="text-[11px] text-foreground-400">Updated July 2026</p>
              </div>
            </div>
          </Link>

          {/* Safety Guide */}
          <Link
            to="/superbuy-spreadsheet-safety-guide"
            className="bg-background-100 rounded-2xl p-6 cursor-pointer hover:bg-accent-50/80 transition-colors group"
          >
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 rounded-lg text-xs font-semibold mb-4">
              Safety
            </span>
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
              Superbuy Spreadsheet Safety Guide
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              Complete safety guide covering data privacy, verification tips, and best practices for secure online product research. Independent educational resource with practical protection strategies.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                <i className="ri-shield-check-line text-secondary-700 text-xs"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-900">SuperbuySpread Team</p>
                <p className="text-[11px] text-foreground-400">Updated July 2026</p>
              </div>
            </div>
          </Link>

          {/* Beginner Tutorial */}
          <Link
            to="/superbuy-spreadsheet-beginner-tutorial"
            className="bg-background-100 rounded-2xl p-6 cursor-pointer hover:bg-accent-50/80 transition-colors group"
          >
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 rounded-lg text-xs font-semibold mb-4">
              Beginner
            </span>
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
              How To Use Superbuy Spreadsheet
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              A step-by-step tutorial for absolute beginners. Discover how to browse categories, compare products, read product information, and make your first informed purchase decision with confidence.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <i className="ri-user-line text-accent-700 text-xs"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-900">SuperbuySpread Team</p>
                <p className="text-[11px] text-foreground-400">Updated July 2026</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}